import { Path } from '@/main/router/routerPath';
import { ZakazkaDelbaPP } from '@/modules/servis/zakazka/pracovniPozice/delba';

import { Doklad } from './doklad';
import { JednotnaFrontaNd } from './jednotnaFrontaNd';
import { MontazDV } from './montazDV';
import { Ozakazka } from './ozakazka';
import { Zakazka } from './zakazka';
import { RezervaceND } from './rezervaceND';
import { ZakazkaArchiv } from './zakazkaArchiv';
import { PaketovyModul } from './paketovyModul';
import { CheckIn } from './checkIn';
import { CasovaUdalost } from './casovaUdalost';
import { Zaloha } from './zalohy';
import { PartReturnRequest } from './zakazka/PartReturnRequest';
import { ReverseJobOrder } from './zakazka/ReverseJobOrder';
import { ServiceJob } from './serviceJob';

export const router = new Path('servis').addChildren([
	Doklad.router,
	ServiceJob.router,
	JednotnaFrontaNd.router,
	MontazDV.router,
	Ozakazka.router,
	Zakazka.router,
	RezervaceND.router,
	ZakazkaArchiv.router,
	PaketovyModul.router,
	CheckIn.router,
	CasovaUdalost.router,
	Zaloha.router,
	ZakazkaDelbaPP.router,
	PartReturnRequest.router,
	ReverseJobOrder.router,
]);
